<template>
  <div class="case-details">
    <div class="public-top">
      <div class="public-img">
        <p>打造独一无二的成功案例</p>
      </div>
    </div>
    <div class="case-details-item">
      <div class="label">{{page.label}}</div>
      <el-divider></el-divider>
      <div class="case-details-content">
        <div v-html="page.primary_coverage"></div>
      </div>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
import { caseList } from '@/api/home'

export default {
  name: 'case-details',
  data () {
    return {
      id: this.$route.params.id,
      page: {}
    }
  },
  created () {
    let ldata = caseList()
    let qdata = ldata.find(item => item.id == this.id)
    this.page = qdata
  }
}
</script>

<style lang="scss" scoped>
.case-details {
  .case-details-item {
    margin: 0 auto;
    width: 90%;
    .label {
      margin-top: 2rem;
      text-align: center;
      font-size: 1.6rem;
    }
    .el-divider--horizontal {
      margin: 0.5rem 0;
      height: 0.2rem;
      background: #ff6d00;
    }
    .case-details-content {
      margin-bottom: 2rem;
      > div {
        ::v-deep {
          img {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
    }
  }
}
</style>